export enum Currency {
  "EGP" = "EGP",
  "MAD" = "MAD",
  "$" = "$",
  "SAR" = "SAR",
  "AED" = "AED",
  "KWD" = "KWD",
}
